/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */

import axios from 'axios'
import store from '@/store'
import { ErrorWrapper } from './util'

const API_URL = process.env.VUE_APP_API_URL

export default class Http {
    constructor(status) {
        this.isPublic = status && status.public === true

        const options = {
            baseURL: API_URL + (this.isPublic ? 'public/' : ''),
        }

        if (!this.isPublic) {
            options.headers = {
                Token: store.state.auth.accessToken,
            }
        }

        const service = axios.create(options)

        service.interceptors.response.use(this.handleSuccess, this.handleError)
        this.service = service
    }

    handleSuccess(response) {
        return response
    }

    handleError = (error) => {
        const errorObj = new ErrorWrapper(error.response)

        switch (errorObj.code) {
            case 8:
                store.dispatch('auth/signOut').then()
                break
        }

        return Promise.reject(error)
    }

    post(payload) {
        return this.service.request({
            method: 'POST',
            responseType: 'json',
            data: payload,
        })
    }
}
